<template>
  <div class="c-main">
    <h3 class="c-title c-title--page-section">{{$t('member.add')}}</h3>

    <member @submit="update($event)"></member>
  </div>
</template>

<script>
	export default {
		name: "member-add",
    components: {
      member: require('./member.vue').default,
    },
		methods: {
			update: function(member) {
        this.$notify.saveAsync(
            this.$t('member'),
            this.$store.dispatch('member.add', {data: member}),
            () => {
              this.$navigation.goto({name: 'event.clubs.members'})
            }
        );
			}
		},
	};
</script>

<style>
</style>
